import { Link } from "react-router-dom";

import { ROUTES } from "../common";
import messages from "../messages/ja.json";
import { AuthShell } from "../parts/auth-shell";

import "../styles/auth-flow.css";

export function NotFoundPage() {
  return (
    <AuthShell title={messages.notFound.title}>
      <div className="not-found-body">
        <p className="not-found-code">404</p>
        <Link to={ROUTES.checkin} className="primary-button button-full">
          {messages.notFound.backToCheckin}
        </Link>
      </div>
    </AuthShell>
  );
}
